import api from '@/common/api/cobrandApiClient'
import { ACCOUNT_QUERY_KEY } from '@/constants'
import {
  FETCH_CARDS_START,
  FETCH_CARDS_SUCCESS,
  FETCH_CARDS_ERROR,
  BIND_CARD_START,
  BIND_CARD_GAME_SUCCESS,
  BIND_CARD_SUCCESS,
  BIND_CARD_ERROR,
  FETCH_CARDS_BONUSES_START,
  FETCH_CARDS_BONUSES_SUCCESS,
  FETCH_CARDS_BONUSES_ERROR,
  CHANGE_CARD_DESIGN_START,
  CHANGE_CARD_DESIGN_SUCCESS,
  CHANGE_CARD_DESIGN_ERROR
} from './mutation-types'

/**
 * Get user cards list
 * @param {ActionContext} context
 * @param {Object} payload
 * @param {string[]} payload.include
 */
export async function fetchCards ({ commit, rootState }, options = {}) {
  commit(FETCH_CARDS_START)
  try {
    const accountId = rootState.auth.user.id
    const result = await api.fetchCards(accountId, options)

    commit(FETCH_CARDS_SUCCESS, result)
  } catch (error) {
    commit(FETCH_CARDS_ERROR, error)
    throw error
  }
}

export async function fetchCardsBonuses ({ commit, rootState }, options = {}) {
  commit(FETCH_CARDS_BONUSES_START)
  try {
    const accountId = rootState.auth.user.id
    const { bonuses } = await api.fetchCardsBonuses(accountId, options)

    commit(FETCH_CARDS_BONUSES_SUCCESS, bonuses)
  } catch (error) {
    commit(FETCH_CARDS_BONUSES_ERROR, error)
    throw error
  }
}

/**
 * Change card design
 * @param {ActionContext} context
 * @param {Object} payload
 * @param {string} payload.design
 * @param {string} payload.cardCode
 */
export async function changeCardDesign ({ commit, rootState }, { design, cardCode }) {
  commit(CHANGE_CARD_DESIGN_START)
  try {
    const accountId = rootState.auth.user.id
    const result = await api.changeCardDesign({ [ACCOUNT_QUERY_KEY]: accountId, design, card_code: cardCode })

    commit(CHANGE_CARD_DESIGN_SUCCESS, result)
  } catch (error) {
    commit(CHANGE_CARD_DESIGN_ERROR, error)
    throw error
  }
}

/**
 * Bind card to account
 * @param {ActionContext} context
 * @param {Object} payload
 * @param {string} payload.game
 * @param {string} payload.cardCode
 */
export async function bindCard ({ commit, rootState }, { game, cardCode, callback }) {
  commit(BIND_CARD_START)
  try {
    const accountId = rootState.auth.user.id

    const result = await api.bindCard({ [ACCOUNT_QUERY_KEY]: accountId, game, card_code: cardCode })
    callback(result)
    commit(BIND_CARD_SUCCESS)
  } catch (error) {
    commit(BIND_CARD_ERROR, error)
    throw error
  }
}

/**
 * Change game card is bound to
 * @param {ActionContext} context
 * @param {Object} payload
 * @param {string} payload.game
 * @param {string} payload.cardCode
 */
export async function changeCardGame ({ commit, rootState }, { game, cardCode }) {
  commit(BIND_CARD_START)
  try {
    const accountId = rootState.auth.user.id
    const result = await api.changeCardGame({ [ACCOUNT_QUERY_KEY]: accountId, game, card_code: cardCode })

    commit(BIND_CARD_GAME_SUCCESS, result)
  } catch (error) {
    commit(BIND_CARD_ERROR, error)
    throw error
  }
}
